module.exports = __webpack_public_path__ + "static/media/3-1.e2769b38.jpg";